import * as React from "react"
import { Box } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"

import { productPageImageDetailsReportIssueData } from "../../@signals"


export default function reportIssueColumn() {
    return {
        name: 'skuID', label: 'Report Issue',
        options: {
            filter: false,
            sort: false,
            setCellHeaderProps: () => ({ sx: { minWidth: 100, textAlign: 'center', whiteSpace: 'nowrap' } }),
            customBodyRowRenderLite: (_, dataRow) => (
                <Box sx={{ textAlign: 'center' }}>
                    <IconSeeker
                        icon='bug'
                        tooltip='Report Issue'
                        sx={{ fontSize: '1rem', color: '#f1c40f', opacity: 0.8, cursor: 'pointer' }}
                        onClick={() => {
                            productPageImageDetailsReportIssueData.value = {
                                skuID: dataRow.skuID,
                                sku: dataRow.sku,
                                ean: dataRow.ean,
                                siteID: dataRow.siteID,
                                retailer: dataRow.retailer,
                                date: dataRow.date
                            }
                        }}
                    />
                </Box>
            )
        }
    }
}
